<template>
  <v-container>
    <div><h2>Profile Creation</h2></div>
    <v-divider class="mb-5" />

    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-card v-if="model" flat>
        <!-- <v-row class="mr-3 ml-3">
          <v-col class="ml-auto" md="auto">
            <v-btn :disabled="invalid || isMaster" color="primary" @click="save">Save</v-btn>
          </v-col>
        </v-row> -->

        <!-- Profile Details -->
        <IdentityDetailsCard
          :model="model"
          :userId="null"
          :isNewRecord="true"
          @reload="reload"
          @save="save"
        />
      </v-card>
    </ValidationObserver>
  </v-container>
</template>

<script>
import api from '@/api';
import { mapGetters } from 'vuex';
import IdentityDetailsCard from '@/components/Identity/identityDetailsCard';
import ApiError from '@/api/ApiError';
import { ProfileStatus } from '@/api/auth/membership';
import { v4 as uuidv4 } from 'uuid';
import { profileGender } from '@/data/constants';

export default {
  name: 'ProfileNew',
  components: {
    IdentityDetailsCard,
  },
  props: {
    id: {},
    selectedRole: () => 'customer',
  },
  data() {
    return {
      model: null,
    };
  },
  mounted() {
    this.reload();
  },
  computed: {
    ...mapGetters('auth', ['role', 'isMaster']),
    isNewRecord() {
      return !this.id || this.id === 'new';
    },
  },
  methods: {
    async reload() {
      if (this.isNewRecord) {
        // Initialize new profile with default values
        this.model = {
          name: '',
          // email: '',
          phone: '',
          gender: 'male',
          genderPreference: 'both',
          locationDistrict: '',
          role: this.selectedRole,
          enabled: true,
          status: ProfileStatus.accepted,
          // Admin/Staff specific fields
          username: '',
          password: this.selectedRole === 'admin' ? '' : uuidv4(),
          // Customer specific fields
          referral: false,
          location: '',
          tags: [],
          birthYear: null,
          education: '',
          height: null,
          occupation: '',
          personalTags: [],
          photos: [],
          relationshipType: '',
          favouriteActivities: [],
          communicationLanguage: '',
          mbti: '',
          foodPreferences: [],

          // Emergency contacts
          // emergencyContacts: {
          //   name: '',
          //   phone: '',
          //   relationship: '',
          // },
        };
      }
    },
    async save() {
      try {
        if (!(await this.$refs.form?.validate?.())) {
          return;
        }

        // Prepare payload with only necessary fields for creation
        const payload = this.getCreationFields();

        const response = await api.post('/v1/users/createUser', payload);

        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Profile created successfully',
          type: 'success',
          color: 'success',
        });

        // Navigate back to profiles list
        this.$router.push({ name: 'Profiles', query: { role: this.selectedRole } });
      } catch (e) {
        const ae = ApiError.wrap(e);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: ae.message,
          type: 'error',
          color: 'error',
        });
      }
    },
    getCreationFields() {
      // Include all fields from the model that are relevant for profile creation
      const payload = {
        name: this.model.name,
        // email: this.model.email,
        // phone: this.model.phone,
        gender: this.model.gender,
        role: this.model.role,
        password: this.model.password,
      };

      // For admin profiles, use the provided username, for others use phone as username
      if (this.model.role === 'admin') {
        payload.username = this.model.username;
        payload.gender = profileGender.unknown;
      } else {
        payload.phone = this.model.phone;
        payload.username = this.model.phone;
        // Include additional fields for non-admin profiles
        payload.genderPreference = this.model.genderPreference;
        payload.locationDistrict = this.model.locationDistrict;
      }

      // Include customer-specific fields if it's a customer profile
      if (this.model.role === 'customer') {
        Object.assign(payload, {
          referral: this.model.referral,
          location: this.model.location,
          tags: this.model.tags,
          birthYear: this.model.birthYear,
          education: this.model.education,
          height: this.model.height,
          occupation: this.model.occupation,
          personalTags: this.model.personalTags,
          photos: this.model.photos,
          relationshipType: this.model.relationshipType,
          favouriteActivities: this.model.favouriteActivities,
          communicationLanguage: this.model.communicationLanguage,
          mbti: this.model.mbti,
          foodPreferences: this.model.foodPreferences,
        });
      }

      // // Include emergency contacts if they exist
      // if (
      //   this.model.emergencyContacts &&
      //   (this.model.emergencyContacts.name || this.model.emergencyContacts.phone)
      // ) {
      //   payload.emergencyContacts = this.model.emergencyContacts;
      // }

      // // Include metadata if it has meaningful content
      // if (
      //   this.model.metadata &&
      //   Object.keys(this.model.metadata).some(key => this.model.metadata[key])
      // ) {
      //   payload.metadata = this.model.metadata;
      // }

      return payload;
    },
  },
};
</script>
